module.exports = __webpack_public_path__ + "media/houseWithMoreHills.9f8bfe86.png";